<h1 class="page-title mb-5">الاسئلة الشائعة
</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="faq-item" *ngFor="let item of items">
          <div class="faq-header" (click)="toggle(item)">
            <div class="indicator" [class.expanded]="item.expanded">
              <i class="fa-solid" [class.fa-minus]="item.expanded" [class.fa-plus]="!item.expanded"></i>
            </div>
            <div class="title">{{ item.title }}</div>
          </div>
          <div class="faq-content" *ngIf="item.expanded">
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>